










import Vue from "vue";
import Component from "vue-class-component";
import { AtendimentoService } from "@/services/atendimento.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboMotivoFechamento extends Vue {
  @Prop() readonly value!: number | null;
  @Prop() readonly motivo!: any;
  loading = false;
  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];

  @Watch("value")
  onValueChange(val: string | null) {
    this.tipo = this.itemsTipo.find((x) => x.value == val) ?? null;
  }

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchMotivoFechamento() {
    this.loading = true;
    const res = await AtendimentoService.ObterMotivoFechamento();
    this.itemsTipo = res.map((x) => ({
      text: x.descricao,
      value: x.idMotivoFechamentoAtendimento,
    }));

    this.itemsTipo.unshift({ text: "", value: null });

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchMotivoFechamento();
  }
}
